import { createRouter } from '@tanstack/react-router';
import {
  DefaultErrorComponent,
  DefaultNotFoundComponent,
} from '@/common/ErrorScreen';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  // TODO: Is this how URLs are set up on the site? It seems like it on "https://worldbibleschool.org/login/?action=lostpassword" (slash before the '?')
  trailingSlash: 'always',
  // WBS 7.10. Without these a route that throws renders nothing at all: React
  // unmounts the subtree and, with no boundary above it, the page just goes
  // blank. Set as router defaults rather than per route so a route added later
  // inherits them instead of having to remember.
  defaultErrorComponent: DefaultErrorComponent,
  defaultNotFoundComponent: DefaultNotFoundComponent,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
